import * as React from 'react'
import { EditButton } from 'react-admin'
import { FC } from 'react'
import CardActions from '@mui/material/CardActions'

interface CustomLayoutWithHeaderProps {
  // basePath?: string;
  children?: any
  header: JSX.Element
  // record?: { [key: string]: any };
  redirect?: string
}

export const CustomLayoutWithHeader: FC<CustomLayoutWithHeaderProps> = (props: CustomLayoutWithHeaderProps) => {
  const { children, header, ...rest } = props

  return (
    <>
      {/* {hasCreate || hasEdit && ( */}
      <CardActions
        style={{
          zIndex: 2,
          display: 'inline-block',
          float: 'right',
        }}
      >
        {/* {hasEdit && <EditButton basePath={basePath} record={record} />} */}
        {/* Add your custom actions
        <Button color="primary" onClick={() => console.log('custom action')}>Custom Action</Button> */}
      </CardActions>
      {/* )} */}
      {header && React.cloneElement(header)}
      {React.cloneElement(React.Children.only(children), rest)}
    </>
  )
}
